module.exports = __webpack_public_path__ + "0f7f905a0b42b62f75c0253a831256a8.svg";